import styled from "styled-components";
import InfoIcon from "@mui/icons-material/Info";
import { Typography, Box, Paper, FormGroup } from "@mui/material";
import { Tooltip } from "@mui/material";

export const FormGroupWithMargin = styled(FormGroup)(({ theme }) => ({
  marginTop: "16px",
  marginBottom: "16px",
  width: "100%",
  backgroundColor : 'rgba(132, 73, 2, 0.08)',
borderRadius:'6px',
padding:'8px'
}));

export const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
  height: calc(100vh - 128px);
  overflow-y: auto;
`;

export const ProfileSection = styled.div`
  background: ${({ theme }) => theme.colors.background};
  padding: 2rem;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  margin-bottom: 0.5rem;
`;

// Main container
export const ProfileContainer = styled.div`
  margin: 0 auto;
  font-family: ${({ theme }) => theme.fonts?.body || "sans-serif"};
  padding: ${({ theme }) => theme.spacing.lg};

  @media (max-width: 1279px) and (min-width: 768px) {
    padding: ${({ theme }) => theme.spacing.sm};
    width: 100%;
  }

  @media (max-width: 767px) {
    box-shadow: none;
    padding: ${({ theme }) => theme.spacing.xs};
    width: 100%;
  }
`;

export const QRIcon = styled.div`
  cursor: pointer;
  margin-left: 10px;
  vertical-align: middle;
  color: ${({ theme }) => theme.colors.primary};
`;

export const QrPopover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const QrContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  position: relative;
  width: 280px;
`;

export const CloseButtonBusInfo = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
`;

export const QrCodeContainer = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const StoreName = styled.div`
  font-weight: bold;
  width: 100%;
  text-align: center;
`;

export const DownloadButtonQR = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 20px auto 0;
  padding: 8px 16px;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    opacity: 0.9;
  }
`;

// Styled tab components
export const TabsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
`;

export const TabBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border || "#e0e0e0"};
  margin-bottom: 1rem;
  background: transparent;

  @media (max-width: 767px) {
    margin-bottom: 0.5rem;
  }
`;

export const TabButton = styled.button<{ $active: boolean }>`
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : theme.colors.text || "#666"};
  border-bottom: 2px solid;
  border-color: ${({ $active, theme }) =>
    $active ? theme.colors.primary : "transparent"};
  padding: 0.75rem 1.5rem;
  margin: 0 0.5rem;
  transition: color 0.2s, border-color 0.2s;
  border-radius: 4px 4px 0 0;
  position: relative;
  z-index: 1;
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.primaryDark || theme.colors.primary};
    background: ${({ theme }) =>
      theme.colors.backgroundLightPrimary || "#f8f8f8"};
  }
  @media (max-width: 1023px) {
    font-size: 0.875rem;
    padding: 0.6rem 1.2rem;
  }
  @media (max-width: 767px) {
    font-size: 0.875rem;
    padding: 0.6rem 1rem;
  }
`;

export const TabPanels = styled.div`
  width: 100%;
`;

export const TabPanel = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? "block" : "none")};
  width: 100%;
  animation: fadeIn 0.4s;
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

// Profile sections

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-radius: 8px;
  padding: ${({ theme }) => theme.spacing.md};

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ProfileName = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: 600;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1.3;
`;

export const ProfileInfoTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1.5rem;
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid ${({ theme }) => theme.colors.gray};

  @media (min-width: 768px) {
    font-size: 1.375rem;
  }
`;

export const ProfileInfoContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 16px;
  gap: 2rem;
  width: 100%;

  @media (max-width: 1028px) {
    grid-template-columns: 1fr;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }
`;

export const BusinessInfo = styled.div`
  padding-top: ${({ theme }) => theme.spacing.md};
`;

export const ProfileInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.underline};
  gap: 1rem;
  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ProfileDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0 12px 0;
  gap: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.underline};
  @media (min-width: 1920px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const InfoTitle = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.darkGray};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  min-width: 160px;
  margin-right: 16px;
`;

export const InfoDescription = styled.div<{
  $align?: string;
}>`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: 500;
  display: flex;
  align-items: center;
  flex: 1;
  text-align: ${({ $align }) => $align || "left"};

  @media (min-width: 1920px) {
    justify-content: flex-end;
    text-align: right;
  }
`;

// Shop details specific styles
export const ShopDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  width: 100%;

  @media (max-width: 1280px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  & > div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
`;

export const BusinessHoursItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #eee;
`;

export const BusinessHoursStatus = styled.span<{ isOpen: boolean }>`
  color: ${({ isOpen }) => (isOpen ? "#28a745" : "#dc3545")};
  font-weight: 500;
`;

export const DocumentItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0;
  border-bottom: 1px solid #eee;
`;

export const DocumentStatus = styled.span<{ status: string }>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 24px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  background-color: ${({ status, theme }) =>
    status === "completed"
      ? theme.colors.secondary
      : status === "pending"
      ? theme.colors.gray
      : status === "rejected"
      ? theme.colors.error
      : theme.colors.primary};
  color: ${({ status, theme }) =>
    status === "pending" ? theme.colors.text : theme.colors.TextWhite};
`;

// Buttons
export const Button = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const EditButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.TextWhite};
`;

export const UploadButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.backgroundLightPrimary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
  }
`;

export const DeactivateButton = styled.div<{
  $width?: string;
}>`
  border: 1px solid #a5a5a5;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.fontSizes.large};
  font-weight: ${({ theme }) => theme.fontWeights.xbold};
  color: #a5a5a5;
  height: 38px;
  width: ${({ $width }) => $width || "251px"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
`;

// QR Code Popover Styles
export const QrCodePopover = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const QrCodeContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
  max-width: 90%;
  max-height: 90%;
  overflow: auto;
`;

export const QrCodeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const QrCodeTitle = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  color: #333;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;

  &:hover {
    color: #333;
  }
`;

export const QrCodeWrapper = styled.div`
  margin: 1rem 0;
  display: flex;
  justify-content: center;
`;

export const DownloadButton = styled.button`
  background-color: ${({ theme }) => theme.colors.secondary};
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  cursor: pointer;
  margin-top: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "16px 0",
}));

export const DocumentTooltip = styled(Tooltip)(({ theme }) => ({
  marginLeft: "12px",
  marginTop: "-4px",
  "& .MuiTooltip-tooltip": {
    maxWidth: "300px",
    fontSize: "0.875rem",
  },
}));

export const DocumentCard = styled(Paper)(({ theme }) => ({
  padding: "16px",
  marginBottom: "24px",
  border: `1px solid ` + theme.colors.underline,
  borderRadius: "12px !important",
  backgroundColor: theme.colors.white,
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
  cursor: "pointer",
}));

export const DocumentHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
});

export const DocumentLabel = styled("span")(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 500,
  color: theme.colors.primary,
  display: "flex",
  alignItems: "center",
}));

export const RequiredAsterisk = styled("span")(({ theme }) => ({
  color: theme.colors.error,
  marginLeft: "4px",
  fontSize: "1rem",
}));

export const StatusBadge = styled("span").withConfig({
  shouldForwardProp: (prop) => prop !== '$status',
})<{
  $status: "pending" | "unapproved" | "approved" | "not-uploaded";
}>(({ theme, $status }) => ({
  padding: "6px 12px",
  borderRadius: "20px",
  fontSize: "0.75rem",
  fontWeight: 500,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
  ...($status === "pending" && {
    backgroundColor: "#FFF3E0",
    color: "#E39435",
    border: "1px solid #FFB74D",
  }),
  ...($status === "unapproved" && {
    backgroundColor: "#FFEBEE",
    color: "#C62828",
    border: "1px solid #EF5350",
  }),
  ...($status === "approved" && {
    backgroundColor: "#E8F5E9",
    color: "#2E7D32",
    border: "1px solid #66BB6A",
  }),
  ...($status === "not-uploaded" && {
    backgroundColor: theme.colors.underline,
    color: theme.colors.text,
    border: `1px solid ${theme.colors.lightGray}`,
  }),
}));

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.colors.text,
  fontSize: "0.875rem",
  marginTop: "8px",
  padding: "8px 12px",
  backgroundColor: theme.colors.error + "20",
  borderRadius: "6px",
  border: `1px solid ` + theme.colors.lightGray,
}));

export const InfoTooltipIcon = styled(InfoIcon)(({ theme }) => ({
  fontSize: "1.2rem",
  color: "#E39435",
  cursor: "pointer",
  "&:hover": {
    color: "#E39435",
  },
}));
